import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { useLiveStatus, useMyView, useViewers, ViewerAvatars, viewersLabel, type LiveStatus } from '@/lib/realtime'
import { cn } from '@/lib/utils'

const COPY: Record<LiveStatus, { label: string; hint: string; tone: string }> = {
  ao_vivo: { label: 'Ao vivo', hint: 'O que as outras pessoas mudam aparece aqui sem recarregar.', tone: 'bg-success' },
  conectando: { label: 'Conectando', hint: 'Ligando o tempo real…', tone: 'bg-warning animate-pulse' },
  caiu: {
    label: 'Reconectando',
    hint: 'A conexão ao vivo caiu e está voltando sozinha. As telas seguem funcionando.',
    tone: 'bg-warning animate-pulse',
  },
  desligado: { label: 'Sem tempo real', hint: 'Tempo real desligado.', tone: 'bg-muted-foreground/50' },
}

/**
 * Ponto no topo: verde quando o Supply está recebendo as mudanças ao vivo.
 * Sem ele, "não mudou nada" e "não estou vendo" ficam iguais. Na reunião,
 * mostra também quem mais está com a mesma ATA aberta.
 */
export function LiveIndicator() {
  const status = useLiveStatus()
  const view = useMyView()
  const viewers = useViewers(view?.startsWith('ata:') ? view : null)
  const copy = COPY[status]
  return (
    <div className="flex items-center gap-2">
      {viewers.length > 0 && (
        <span role="status" aria-label={viewersLabel(viewers, 'esta ATA')} title={viewersLabel(viewers, 'esta ATA')} className="flex items-center">
          <ViewerAvatars viewers={viewers} />
        </span>
      )}
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            role="status"
            tabIndex={0}
            aria-label={`${copy.label}. ${copy.hint}`}
            className="inline-flex h-8 items-center gap-1.5 rounded-md px-1.5 text-[11px] text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <span className={cn('h-2 w-2 rounded-full', copy.tone)} aria-hidden />
            <span className="hidden lg:inline">{copy.label}</span>
          </span>
        </TooltipTrigger>
        <TooltipContent>{copy.hint}</TooltipContent>
      </Tooltip>
    </div>
  )
}
